/******
 *
 * formulas used
 * market cap=close price for specific period+no of outstanding shares
 * using reported financials
 */

import React, { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import axios from "axios";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  mode: "dark",
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontSize: 12,
    fontFamily: "public sans",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    fontFamily: "public sans",
  },
}));

const MarketCapsChart = ({
  reportedFinancials,
  mode,
  financialPeriod,
  symbol,
  token,
  isComparing,
}) => {
  const [dataView, setDataView] = useState(false);
  const [growthData, setGrowthData] = useState();
  const [timePeriods, setTP] = useState([]);
  const [marketCaps, setMC] = useState([]);
  const [AllCompNetInc, setAllCompNetInc] = useState([]);

  useEffect(() => {
    if (!isComparing) {
      console.log("reportedFinancials in mc", reportedFinancials);
      if (financialPeriod == "quarterly") {
        const fetchChart = async (fetchDate) => {
          let x = await axios.get(
            `https://cloud.iexapis.com/stable/stock/${symbol}/chart/date/${fetchDate}?chartCloseOnly=true&&chartByDay=true&&token=${token}`
          );
          return x;
        };
        const getMarketSharePrice = async (periodEnd) => {
          let chartData = {};
          let periodEndDate = new Date(periodEnd);
          //   console.log("dateForFetch", dateForFetch, symbol, token);

          let i = 0;
          while (i < 4) {
            let year = periodEndDate.getUTCFullYear();
            let month = periodEndDate.getUTCMonth() + 1;
            let day = periodEndDate.getUTCDate() - i;
            if (month < 10) {
              month = "0" + month.toString();
            }
            if (day < 10) {
              day = "0" + day.toString();
            }
            let dateForFetch = parseInt(
              year?.toString() + month?.toString() + day?.toString()
            );
            // console.log("turn", i, " fetch date", dateForFetch);
            /********* */
            chartData = await fetchChart(dateForFetch);
            if (chartData?.data?.length > 0) {
              //   console.log("chart data", chartData?.data);
              i = 4;
              return chartData?.data[0]?.date ? chartData?.data[0] : {};
            }

            /********* */
            i++;
          }
        };

        const calculateMarketCap = async () => {
          if (reportedFinancials?.quarterly?.length > 0) {
            let temp = [];
            reportedFinancials?.quarterly.map(async (fin, i) => {
              // console.log("reported financials for pe", fin);

              let p = fin?.periodEnd;
              // console.log("period", p);
              let price = await getMarketSharePrice(p);
              //   console.log("price", price);
              let outstandingShares = fin?.CommonStockSharesOutstanding
                ? fin?.CommonStockSharesOutstanding
                : fin?.EntityCommonStockSharesOutstanding;
              //   console.log("outstandingShares", outstandingShares);
              //   //   console.log("fin", fin);
              //   console.log(
              //     "market cap",
              //     numFormatter(price?.close * outstandingShares)
              //   );
              let marketCap = price?.close * outstandingShares;
              if (marketCap > 1) {
                let obj = {
                  fiscalPeriod: fin?.DocumentFiscalPeriodFocus
                    ? `FY${fin?.DocumentFiscalYearFocus - 2000} ${
                        fin?.DocumentFiscalPeriodFocus
                      }`
                    : fin?.fiscalQuarter
                    ? `FY${fin?.fiscalYear - 2000} Q${fin?.fiscalQuarter}`
                    : fin?.formFiscalYear
                    ? `FY${fin?.formFiscalYear - 2000} Q${
                        fin?.formFiscalQuarter
                      }`
                    : `FY Q `,
                  marketCap: marketCap,
                  index: i,
                };
                temp?.push(obj);
                // console.log("obj", i, temp);
                // console.log("market cap data temp", temp);
                let sortedData = temp.sort((a, b) => {
                  return b.index - a.index;
                });
                // console.log(
                //   temp?.length > reportedFinancials?.quarterly?.length - 4
                // );
                if (temp?.length > reportedFinancials?.quarterly?.length - 4) {
                  // console.log("market cap data", sortedData);

                  setTP(sortedData.map((t) => t?.fiscalPeriod));
                  setMC(sortedData.map((t) => t?.marketCap.toFixed(2)));
                }
              }
            });
          }
        };
        calculateMarketCap();
      } else {
        const fetchChart = async (fetchDate) => {
          let x = await axios.get(
            `https://cloud.iexapis.com/stable/stock/${symbol}/chart/date/${fetchDate}?chartCloseOnly=true&&chartByDay=true&&token=${token}`
          );
          return x;
        };
        const getMarketSharePrice = async (periodEnd) => {
          let chartData = {};
          let periodEndDate = new Date(periodEnd);
          //   console.log("dateForFetch", dateForFetch, symbol, token);

          let i = 0;
          while (i < 4) {
            let year = periodEndDate.getUTCFullYear();
            let month = periodEndDate.getUTCMonth() + 1;
            let day = periodEndDate.getUTCDate() - i;
            if (month < 10) {
              month = "0" + month.toString();
            }
            if (day < 10) {
              day = "0" + day.toString();
            }
            let dateForFetch = parseInt(
              year?.toString() + month?.toString() + day?.toString()
            );
            console.log();
            /********* */
            chartData = await fetchChart(dateForFetch);
            if (chartData?.data?.length > 0) {
              // console.log(
              //   "turn",
              //   i,
              //   " fetch date",
              //   dateForFetch,
              //   "chart data",
              //   chartData?.data
              // );
              i = 4;
              return chartData?.data[0]?.date ? chartData?.data[0] : {};
            }

            /********* */
            i++;
          }
        };

        const calculateMarketCap = async () => {
          if (reportedFinancials?.annual?.length > 0) {
            let temp = [];
            reportedFinancials?.annual.map(async (fin, i) => {
              // console.log("reported financials for pe", fin);

              let p = fin?.periodEnd;
              // console.log("period", p);
              let price = await getMarketSharePrice(p);
              //   console.log("price", price);
              let outstandingShares = fin?.CommonStockSharesOutstanding
                ? fin?.CommonStockSharesOutstanding
                : fin?.EntityCommonStockSharesOutstanding;

              //   console.log("outstandingShares", outstandingShares);
              //   //   console.log("fin", fin);
              // console.log(
              //   "market cap",
              //   numFormatter(price?.close * outstandingShares)
              // );
              let marketCap = price?.close * outstandingShares;
              // console.log(
              //   "market cap",
              //   marketCap,
              //   price?.close,
              //   outstandingShares
              // );
              if (marketCap > 1) {
                let obj = {
                  fiscalPeriod: fin?.DocumentFiscalYearFocus
                    ? `${fin?.DocumentFiscalYearFocus} `
                    : fin?.fiscalYear
                    ? `${fin?.fiscalYear}`
                    : `${fin?.formFiscalYear} `,
                  marketCap: marketCap,
                  index: i,
                };
                temp?.push(obj);
                //   console.log("temp", temp);
                //   console.log("obj", i, obj);
                // console.log("market cap data temp", temp);
                let sortedData = temp.sort((a, b) => {
                  return b.index - a.index;
                });
                //   console.log(reportedFinancials?.quarterly?.length - temp?.length);

                //   console.log("market cap data", sortedData);

                setTP(sortedData.map((t) => t?.fiscalPeriod));
                setMC(sortedData.map((t) => t?.marketCap.toFixed(2)));
              }
            });
          }
        };
        calculateMarketCap();
      }
    }
    // console.log("changed", financialPeriod, incomeDetails);
  }, [reportedFinancials, financialPeriod]);

  /********while comapring */
  useEffect(() => {
    console.log(
      "reported Financials details",
      financialPeriod,
      reportedFinancials
    );
    if (isComparing && reportedFinancials?.length > 0) {
      console.log(
        "reported Financials details",
        financialPeriod,
        reportedFinancials
      );
      if (financialPeriod == "quarterly") {
        setTP(reportedFinancials.map((t) => t?.financialPeriod));
        let symbols = reportedFinancials[0]?.marketCap?.map(
          (shares) => shares?.symbol
        );
        // console.log("symbols", symbols);
        let series = symbols?.map((sym, ind) => {
          // console.log("sym", sym);
          return reportedFinancials?.map((i) => {
            return i?.marketCap[ind]?.marketCap;
          });
        });
        console.log("series", series);
        setAllCompNetInc(series);
      } else {
        setTP(reportedFinancials.map((t) => t?.financialPeriod));

        let symbols = reportedFinancials[0]?.marketCap?.map(
          (shares) => shares?.symbol
        );
        // console.log("symbols", symbols);
        let series = symbols?.map((sym, ind) => {
          // console.log("sym", sym);
          return reportedFinancials?.map((i) => {
            return i?.marketCap[ind]?.marketCap;
          });
        });
        console.log("series", series);
        setAllCompNetInc(series);
      }
    }
  }, [reportedFinancials, financialPeriod]);

  var options = {
    series: !isComparing
      ? [
          {
            name: "Market Cap",
            data: marketCaps,
          },
        ]
      : AllCompNetInc?.length > 0
      ? reportedFinancials[0]?.marketCap?.map((inc, i) => {
          return { name: inc?.symbol, data: AllCompNetInc[i] };
        })
      : [],
    chart: {
      type: "line",
      height: 1400,
      background: "transparent",
      toolbar: {
        show: true,

        tools: {
          download: true,
          selection: window?.screen?.width > 600 ? true : false,
          zoom: window?.screen?.width > 600 ? true : false,
          zoomin: window?.screen?.width > 600 ? true : false,
          zoomout: window?.screen?.width > 600 ? true : false,
          pan: window?.screen?.width > 600 ? true : false,
          reset: window?.screen?.width > 600 ? true : false,
        },
        export: {
          csv: {
            filename: financialPeriod + " - Market Cap",
            columnDelimiter: ",",
            headerCategory: "Financial Period",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: financialPeriod + " - Market Cap",
          },
          png: {
            filename: financialPeriod + " - Market Cap",
          },
        },
      },
    },
    colors: ["#29d293", "#CA955C"],

    stroke: {
      curve: "smooth",
      width: window?.screen?.width > 600 ? 5 : 3,
      lineCap: "butt",
      colors: ["#29d293", "#CA955C"],
      // OR provide an array
      // curve: ["smooth", "straight", "stepline"],
    },
    //   plotOptions: {
    //     bar: {
    //       horizontal: false,
    //       columnWidth: "75%",
    //       endingShape: "rounded",
    //     },
    //   },
    dataLabels: {
      enabled: false,
    },
    // stroke: {
    //   show: true,
    //   width: 2,
    //   colors: ["transparent"],
    // },
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "top",
      horizontalAlign: "center",
      floating: false,
      fontSize: window?.screen?.width > 600 ? "14px" : "10px",
      fontFamily: "public sans",
      fontWeight: 400,
      labels: {
        useSeriesColors: true,
      },

      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    grid: {
      show: true,
      borderColor: mode == "light" ? "#d9d9d999" : "#d9d9d955",
      row: {},
      xaxis: {
        lines: {
          show: false,
        },
        position: "top",
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    theme: {
      mode: mode,
      //   palette: "palette5",
    },
    xaxis: {
      lines: {
        show: false, //or just here to disable only y axis
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      // axisBorder: {
      //   show: true,
      //   color: "#78909C",
      //   height: 1,
      //   width: "100%",
      //   offsetX: 0,
      //   offsetY: 0,
      // },
      // axisTicks: {
      //   show: true,
      //   borderType: "solid",
      //   color: "#78909C",
      //   height: 6,
      //   offsetX: 0,
      //   offsetY: 0,
      // },

      categories: timePeriods,
      labels: {
        show: true,
        rotate: -50,
        rotateAlways: window?.screen?.width > 768 ? false : true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        maxHeight: 120,
        style: {
          color: new Array(timePeriods?.length)?.fill("#ff0000"),
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      tickAmount: 10,
      title: {
        text: "",
      },
      labels: {
        formatter: function (value) {
          return numFormatter(value.toFixed(2)) + " ";
        },
        style: {
          colors: [],
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-yaxis-label",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "$" + numFormatter(val);
        },
      },
    },
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontFamily: "public sans",
      fontWeight: 300,
    },
  }));

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      backgroundColor: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontWeight: 300,
      fontFamily: "public sans",
    },
  }));
  const [chartDescription, x] = useState(
    "Market Capitalization is calculated by multiplying the price of a stock by its total number of outstanding shares."
  );

  return (
    <div>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "2rem",
          color: "fontPrimaryColor.main",
        }}
        className="chart__title"
      >
        Market Capitalization
      </Box>
      {dataView ? (
        <Box
          sx={{
            minWidth: "300px",
            marginLeft: "50%",
            transform: "translateX(-50%)",
          }}
          onClick={() => console.log("option.series", options?.series)}
        >
          <TableContainer component={Paper}>
            <Table
              sx={{
                minWidth: 50,
                fontFamily: "public sans",
              }}
              size="small"
              aria-label="a dense table"
            >
              <TableHead
                sx={{
                  backgroundColor: "bgSecondary.main",
                  color: "fontSecondaryColor.main",
                }}
              >
                <TableRow
                  sx={{
                    backgroundColor: "bgSecondary.main",
                  }}
                >
                  <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                  >
                    Financial Period
                  </StyledTableCell>
                  {/* <StyledTableCell
                    sx={{
                      color: "fontPrimaryColor.main",
                    }}
                    align="right"
                  >
                    Market Cap
                  </StyledTableCell> */}
                  {options?.series?.length > 0 &&
                    options?.series?.map((ser) => (
                      <StyledTableCell
                        sx={{
                          color: "fontPrimaryColor.main",
                          textAlign: "right",
                        }}
                      >
                        {ser?.name}
                      </StyledTableCell>
                    ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {new Array(timePeriods?.length).fill("1").map((row, i) => (
                  <TableRow
                    key={timePeriods[i]}
                    sx={{
                      backgroundColor: "bgPrimary.main",
                      boxShadow:
                        mode == "dark"
                          ? "#888 0px 0px 0px 1px"
                          : "#e6e6e6 0px 0px 0px 1px",
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      component="th"
                      scope="row"
                    >
                      {timePeriods[i]}
                    </StyledTableCell>
                    {/* <StyledTableCell
                      sx={{
                        color: "fontSecondaryColor.main",
                        borderBottom: "none",
                      }}
                      align="right"
                    >
                      {numFormatter(options?.series[0]?.data[i])}
                    </StyledTableCell> */}
                    {options?.series?.length > 0 &&
                      options?.series?.map((ser) => (
                        <StyledTableCell
                          sx={{
                            color: "fontSecondaryColor.main",
                            borderBottom: "none",
                          }}
                          align="right"
                        >
                          {numFormatter(ser?.data && ser?.data[i])}
                        </StyledTableCell>
                      ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      ) : isComparing ? (
        <>
          {reportedFinancials?.length > 0 && (
            <Chart
              options={options}
              series={options?.series}
              type="line"
              height={window?.screen?.width > 600 ? "200%" : "150%"}
              width="100%"
            />
          )}
        </>
      ) : (
        <Chart
          options={options}
          series={options?.series}
          type="line"
          height={window?.screen?.width > 600 ? "200%" : "150%"}
          width="100%"
        />
      )}

      <Box className="chart__bottom__options__bar" sx={{ gap: "10px" }}>
        <Box
          className="showChartInfoBtn"
          sx={{ backgroundColor: "bgSecondary.main", borderRadius: "50%" }}
        >
          {mode == "dark" ? (
            <LightTooltip title={chartDescription} arrow>
              <Box>
                <QuestionMarkIcon
                  sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
                />
              </Box>
            </LightTooltip>
          ) : (
            <BootstrapTooltip title={chartDescription} arrow>
              <QuestionMarkIcon
                sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
              />
            </BootstrapTooltip>
          )}
        </Box>
        <Box onClick={() => setDataView(!dataView)}>
          <IconButton sx={{ backgroundColor: "bgSecondary.main" }}>
            <ViewListIcon
              sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
            />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default MarketCapsChart;
function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900 && num > 0) {
    return num; // if value < 1000, nothing to do
  } else if (num < -999 && num > -1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num < -1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num < -100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num < -1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num > -900) {
    return num; // if value < 1000, nothing to do
  }
}
